import React, { useContext } from 'react';
import TodoContext from '../todoCtx/TdoCtx';
import "./confirmBox.css";

const ConfirmBox = ({handleDltMarked}) => {

    const {todos,setTodos,writeTask,setWriteTask,setShowCB} = useContext(TodoContext);

    const handleCancel = event => {
        // 👇️ toggle shown stat   
        setShowCB(showCB => !showCB);
    
        // 👇️ or simply set it to true
        // setIsShown(true);
      };

 


  return (
    <div className='confirmBoxWrapper'>

        <div className='confirmBoxContainer'>
        <div>
            <h1>Are you sure to delete all selected items?</h1>
        </div>
        <div className='buttons'>
            <button className='okay' type='button' onClick={event => handleDltMarked(event)}>YES</button>
            <button className='cancel' type='button' onClick={handleCancel}>NO</button>
        </div>
        </div>
    </div>
  )
}

export default ConfirmBox